import {AxiosError} from 'axios';
import {GET_CANDIDATE_SPECIAL_CONSIDERATION_LISTING_QUERY_KEY} from '../../constants/queryKeys';
import {useCustomQuery} from '../../hooks/query';
import axiosClient from '../axiosClient';
import {GET_CANDIDATE_SPECIAL_CONSIDERATION_LISTING_URL} from '../../constants/apiUrls';
import {GenericErrorResponse} from "../typings";

// =============================================================================
// Request & Response Model
// =============================================================================
export interface specialConsiderationRequestModelList {
  uuid: string;
  applcationStatus: string;
  lastUpdateDatetime: string;
  examLevel: string;
  applicationDate: string;
  applicationId: string;
  candidateId: string | null;
  candidateName: string | null;
  applicationStatus: string;
  applicationClosed: boolean;
  groupScType: string | null;
  amendmentDraft: boolean;
}

export interface ListingResponse {
  specialConsiderationRequestModelList: specialConsiderationRequestModelList[];
  errorMsg: string;
  canApplication: boolean;
}

// =============================================================================
// Query
// =============================================================================
interface Input {
  onSuccess?: (data: ListingResponse) => void;
  onError?: (data: AxiosError<GenericErrorResponse>) => void;
}

export const useGetCandidateListing = ({onSuccess, onError}: Input = {}) => {
  const getCandidateSpecialConsiderationListing = async () => {
    const res = await axiosClient.get<ListingResponse>(
        GET_CANDIDATE_SPECIAL_CONSIDERATION_LISTING_URL
    );
    return res.data;
  };

  return useCustomQuery(
      GET_CANDIDATE_SPECIAL_CONSIDERATION_LISTING_QUERY_KEY,
      getCandidateSpecialConsiderationListing,
      {
        onSuccess,
        onError,
      }
  );
};
